import React, { useState, useRef, useEffect } from 'react';

function TextAndVideo({ data, id, dir }) {
  const { title, text, videoUrl } = data;
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    
    const handleEnded = () => {
      setIsPlaying(false);
    };

    const videoElement = videoRef.current;
    
    videoElement.addEventListener('ended', handleEnded);

    return () => {
      videoElement.removeEventListener('ended', handleEnded);
    };
  }, []);

  return (
    <section id={id} dir={dir} className="pt-10 md:pt-16 lg:pt-24">
      <div className="container px-6 max-w-[1218px] mx-auto text-center">
        <h2
          className="font-LibreBaskervilleRegular text-[#4A4A4A] 
          text-clamp14to20 leading-1.4 max-w-[800px] mx-auto">
          {title}
        </h2>
        <div
          className="relative pt-6 lg:pt-9 pb-6 md:pb-9 lg:pb-12"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          <video
            preload="auto"
            muted
            autoPlay
            loop
            src={videoUrl}
            ref={videoRef}
            controls
            className="w-full border border-[#f9f9f9">
            <track kind="captions" label={title} default />
          </video>
          {/* <div
            className={`absolute top-0 left-0 w-full h-full flex 
              items-center justify-center transition-opacity duration-300 ${
              isPlaying && !isHovered ? 'opacity-0' : 'opacity-100'
            }`}>
            <button type="button" onClick={handlePlayPause} className="rounded-full">
              {isPlaying ? (
                <svg
                  className='w-[60px] h-[60px] md:w-[80px] md:h-[80px] lg:w-[100px] lg:h-[100px]'
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="50" fill="#1C7BDD" />
                  <path
                    d="M58.8229 34.0001H51.7658C51.5038 34.0001 51.2915 34.2123 51.2915 34.4742V65.513C51.2915 65.7749 51.5038 65.9871 51.7658 65.9871H58.8229C59.0849 65.9871 59.2971 65.7749 59.2971 65.513V34.4742C59.2971 34.2123 59.0849 34.0001 58.8229 34.0001Z"
                    fill="white"
                  />
                  <path
                    d="M47.5314 34H40.4742C40.2123 34 40 34.2122 40 34.474V65.5129C40 65.7747 40.2123 65.9869 40.4742 65.9869H47.5314C47.7933 65.9869 48.0056 65.7747 48.0056 65.5129V34.474C48.0056 34.2122 47.7933 34 47.5314 34Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <svg
                  className='w-[60px] h-[60px] md:w-[80px] md:h-[80px] lg:w-[100px] lg:h-[100px]'
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="50" fill="#1C7BDD" />
                  <path
                    d="M39.8571 65C39.7093 65 39.5614 64.9619 39.4286 64.8851C39.1633 64.7321 39 64.4489 39 64.1429L39.0009 35.857C39.0009 35.551 39.1641 35.2678 39.4294 35.1148C39.6947 34.9617 40.0213 34.9617 40.2866 35.1148L64.783 49.2577C65.0482 49.4107 65.2115 49.6939 65.2115 49.9999C65.2115 50.3059 65.0482 50.5892 64.783 50.7422L40.2857 64.8851C40.1529 64.9619 40.005 65 39.8571 65Z"
                    fill="white"
                  />
                </svg>
              )}
            </button>
          </div> */}
        </div>
      </div>

      <p className="text-center font-DINRegular px-6 max-w-[1018px] mx-auto text-[#898989]">
        {text}
      </p>
    </section>
  );
}

export default TextAndVideo;
